import { Badge } from '@indipia/ui-core';
import { scheduleStatusBadge, useScheduleStatusName } from '../utils/scheduleStatus';

/**
 * 공사진행상태 칩 — work-log 공용(작업요청 등록 · 현장보고 작성 · 고객리포트 선택 등).
 * 라벨은 공통코드(E01_SCHEDULE_STATUS), 색은 코드값 → Badge status 고정 매핑. 모양은 표준 Badge(D-09 §15.5).
 */
export function StatusChip({ code, className = '' }: { code: string; className?: string }) {
  const statusName = useScheduleStatusName();
  return (
    <Badge status={scheduleStatusBadge(code)} className={`shrink-0 ${className}`.trim()}>
      {statusName(code)}
    </Badge>
  );
}
